import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, ProgressBar, Button } from "react-bootstrap";
import Select from "react-select";
import DataTable from "react-data-table-component";
import {
  HiCurrencyDollar,
  HiClock,
  HiDocumentText,
  HiUserGroup,
} from "react-icons/hi";
import MainCard from "../../../components/Card/MainCard";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { Bar } from "react-chartjs-2";

const Payroll = ({
  recentPayments,
  upcomingPayments,
  upcomingColumns,
  metrics,
  hrMetrics,
  payrollStatus,
}) => {
  const [filterStatus, setFilterStatus] = useState(null);
  const monthLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const statuses = ["paid", "pending", "partially_paid"];
  const statusColors = {
    paid: "rgba(75, 192, 192, 0.6)",
    pending: "rgba(255, 99, 132, 0.6)",
    partially_paid: "rgba(255, 206, 86, 0.6)",
  };

  const labels = Array.from(
    { length: new Date().getMonth() + 1 },
    (_, i) => monthLabels[i],
  );

  const datasets = statuses.map((status) => ({
    label: status,
    backgroundColor: statusColors[status],
    data: labels.map((_, i) => {
      const monthIndex = i + 1;
      const entry = hrMetrics?.payrollSummary?.find(
        (e) => e.month === monthIndex && e.payment_status === status,
      );
      return entry ? Number(entry.total) : 0;
    }),
  }));
  const filteredUpcoming = filterStatus
    ? upcomingPayments.filter((p) => p.status === filterStatus.value)
    : upcomingPayments;
  return (
    <div className="mt-4">
      <Row className="mb-4">
        {metrics ? (
          <>
            <Col md={3}>
              <DashboardCard
                title="Pending Payroll"
                value={`Ksh ${metrics.pendingPayroll?.toLocaleString() || "0"}`}
                icon={<HiCurrencyDollar />}
              />
            </Col>
            <Col md={3}>
              <DashboardCard
                title="Overdue Invoices"
                value={`Ksh ${
                  metrics.overdueInvoices?.toLocaleString() || "0"
                }`}
                icon={<HiClock />}
              />
            </Col>
            <Col md={3}>
              <DashboardCard
                title="Unpaid Taxes"
                value={`Ksh ${metrics.unpaidTaxes?.toLocaleString() || "0"}`}
                icon={<HiDocumentText />}
              />
            </Col>
            <Col md={3}>
              <DashboardCard
                title="Pending Approvals"
                value={metrics.pendingApprovals || "0"}
                icon={<HiUserGroup />}
              />
            </Col>
          </>
        ) : (
          <div>Loading metrics...</div>
        )}
      </Row>

      <Row>
        <Col lg={12}>
          <MainCard title="Payroll Status">
            {payrollStatus.map((item, index) => (
              <div key={index} className="mb-3">
                <div className="d-flex justify-content-between">
                  <span className="text-capitalize">{item.status}</span>
                  <span>
                    {item.count} employees (Ksh {item.total?.toLocaleString()})
                  </span>
                </div>
                <div className="progress">
                  <div
                    className={`progress-bar ${
                      item.status === "paid"
                        ? "bg-success"
                        : item.status === "pending"
                        ? "bg-warning"
                        : "bg-danger"
                    }`}
                    style={{
                      width: `${
                        (item.count /
                          payrollStatus.reduce((a, b) => a + b.count, 0)) *
                        100
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </MainCard>
        </Col>
        <Col md={8}>
          <MainCard title="Payroll Summary" isOption>
            {hrMetrics && (
              <Bar
                data={{
                  labels,
                  datasets,
                }}
                options={{
                  responsive: true,
                  plugins: {
                    title: {
                      display: true,
                      text: "Payroll Summary by Payment Status",
                    },
                    legend: {
                      position: "top",
                    },
                  },
                }}
              />
            )}
          </MainCard>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <MainCard title="Upcoming Salary Payments">
            <Row className="mb-3">
              <Col md={4}>
                <Select
                  options={[
                    { value: "pending", label: "Pending" },
                    { value: "approved", label: "Approved" },
                    { value: "paid", label: "Paid" },
                  ]}
                  isClearable
                  placeholder="Filter by Status"
                  onChange={setFilterStatus}
                />
              </Col>
            </Row>
            <DataTable
              columns={upcomingColumns}
              data={filteredUpcoming}
              pagination
              highlightOnHover
              striped
            />
          </MainCard>
        </Col>
      </Row>
    </div>
  );
};

export default Payroll;

const DashboardCard = ({ title, value, icon }) => (
  // <Link to="/pigs/pigs">
  <Card style={{}}>
    <Card.Body className="">
      <h6 className="mb-4 ">{title}</h6>
      <div className="row d-flex align-items-center">
        <div className="col-9">
          <h5 className="f-w-300 d-flex align-items-center m-b-0 ">
            {value?.toLocaleString()}
          </h5>
        </div>
        <div className="col-3 text-right f-26">{icon}</div>
      </div>
    </Card.Body>
  </Card>
);
